import { ListSubheader } from '@material-ui/core';
import React from 'react';

import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface TimeSelectionHeaderProps {
  title?: string;
  style?: React.CSSProperties;
}

export const TimeSelectionHeader = React.forwardRef<HTMLDivElement, TimeSelectionHeaderProps>(
  ({ title, style }, ref) => {
    const { palette } = useCustomTheme();

    if (!title) {
      return null;
    }

    return (
      <ListSubheader
        ref={ref}
        component="div"
        style={{ backgroundColor: palette.grey[100], color: palette.secondary.main, ...style }}
      >
        <Text tId={title} strong />
      </ListSubheader>
    );
  },
);
